<template>
  <div class="unauthorized-container d-flex align-center justify-center" style="height:100vh" color="primary">
    <v-card class="unauthorized-card" elevation="0" >
      <v-card-title class="text-center">
        <h1>Unauthorized</h1>
      </v-card-title>
      <v-card-text class="text-center">
        <p>You do not have permission to access this page.</p>
        <v-btn color="primary" prepend-icon="mdi-qrcode-scan" class="ma-4" @click="$router.push('/scan-attendee')"
          >Go to scan attendee</v-btn
        >
      </v-card-text>
    </v-card>
  </div>
</template>